import axios from 'axios'
import appconfig from "../app/config";

export const colorService = {
    getMaterialColors,
    getEdgeColors
}

function getMaterialColors() {
    return axios.get(appconfig.Point + 'api/constructor/v1/colors/materials')
        .then((response) => Promise.resolve(response.data))
        .catch((error) => {
            console.error('Error loading material colors:', error);
            // Возвращаем дефолтные цвета в случае ошибки
            return Promise.resolve({
                data: [
                    '#FF0000', '#FF7F00', '#00FF00', '#00FFFF',
                    '#0000FF', '#8B00FF', '#A52A2A', '#FFC0CB', '#808080',
                    '#000000', '#008080', '#FFD700', '#4B0082', '#006400',
                    '#FF1493', '#00CED1', '#7FFF00', '#DA70D6', '#FF4500'
                ]
            });
        })
}

function getEdgeColors() {
    return axios.get(appconfig.Point + 'api/constructor/v1/colors/edges')
        .then((response) => Promise.resolve(response.data))
        .catch((error) => {
            console.error('Error loading edge colors:', error);
            // Возвращаем дефолтные цвета в случае ошибки
            return Promise.resolve({
                data: [
                    '#FF0000', '#FF7F00', '#00FF00', '#00FFFF',
                    '#0000FF', '#8B00FF', '#A52A2A', '#FFC0CB', '#808080',
                    '#000000', '#008080', '#FFD700', '#4B0082', '#006400',
                    '#FF1493', '#00CED1', '#7FFF00', '#DA70D6', '#FF4500'
                ]
            });
        })
} 